export function PointSelectionHeader() {
  return (
    <div className="flex items-center">
      <i className="mr-2 -mt-1 text-xl icon-lt-map-pin text-neutral-600" />
      <div className="flex-col">
        <span className="overflow-hidden text-xs font-semibold truncate whitespace-pre-line text-text-base-tertiary text-ellipsis max-h-16 line-clamp-3">
          POINT
        </span>
      </div>
    </div>
  );
}
